import { render, staticRenderFns } from "./remote.vue?vue&type=template&id=3d98960a&scoped=true"
import script from "./remote.vue?vue&type=script&lang=js"
export * from "./remote.vue?vue&type=script&lang=js"
import style0 from "./remote.vue?vue&type=style&index=0&id=3d98960a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98960a",
  null
  
)

export default component.exports